import { Clickable } from '@carvana/merch-components';
import cx from 'classnames';
import { useState } from 'react';
import type { QuestionAndAnswer } from '~/contracts/ev-tax-credit';
import Minus from '~/icons/Minus';
import Plus from '~/icons/Plus';
import { StyledQuestion } from './FrequentlyAskedQuestions.styles';

export default function Question({ question, answer }: QuestionAndAnswer) {
  const [isExpanded, setExpanded] = useState(false);

  return (
    <StyledQuestion>
      <Clickable
        onClick={() => setExpanded(v => !v)}
        data-analytics-id="FAQ - Toggle Question"
        data-analytics-attributes={JSON.stringify({ question })}
        className="grid grid-cols-[1fr_auto] gap-xl"
      >
        <h3 className="text-text-strong t-strong-md">{question}</h3>
        {isExpanded ? (
          <Minus className="text-icon-strong" />
        ) : (
          <Plus className="text-icon-strong" />
        )}
      </Clickable>
      <div
        className={cx('grid gap-xl text-text-default t-body-md', {
          hidden: !isExpanded
        })}
      >
        {answer}
      </div>
    </StyledQuestion>
  );
}
